import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation CreateChatFeedback($input: ChatFeedbackInput!) {
    createChatFeedback(input: $input) {
      id
    }
  }
`);
